// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3U-Qn","footer":"ModalFilter_footer__1Oou9"};